import React from "react";
import styles from "./style.module.scss";

interface IProps {
  visible?: boolean;
  isFull?: boolean;
  width?: number;
  color?: string;
  strokeWidth?: number;
}

export default function Loading({
  visible = true,
  isFull = true,
  width = 35,
  color = "black",
  strokeWidth = 3.5,
}: IProps) {
  if (!visible) {
    return <></>;
  }

  const loadingStyle: React.CSSProperties = {width, height: width * 0.9};
  const barStyle: React.CSSProperties = {
    backgroundColor: color,
    width: strokeWidth,
  };

  return (
    <div
      className={[styles.container, isFull ? styles.full : undefined].join(" ")}
      style={isFull ? {} : {width}}>
      <div className={styles.loadding} style={loadingStyle}>
        <div className={styles.dot} style={barStyle}></div>
        <div className={styles.dot} style={barStyle}></div>
        <div className={styles.dot} style={barStyle}></div>
        <div className={styles.dot} style={barStyle}></div>
      </div>
    </div>
  );
}
